@if (!useRedesignedCard()) {
  <mwe-tooltip-card
    iconClass="fas fa-user"
    [header]="tooltipHeader()"
    [content]="tooltipContent()"
    [isClickable]="isClickable()"
    [cardClass]="tooltipCardClass()"
    (onClick)="emitOnClickEvent()"
    [hasTooltipBody]="hasContent()"
  >
    <ng-content slot="tooltip-body" />
  </mwe-tooltip-card>
}

@if (useRedesignedCard()) {
  <mwe-selection-card
    iconClass="fa-solid fa-user"
    [header]="tooltipHeader()"
    [content]="tooltipContent()"
    [isClickable]="isClickable()"
    (onClick)="emitOnClickEvent()"
  />
}
